import type { CSSProperties } from 'react'
import { artImageStyle, artUrl, hasArt } from '../lib/cardArt'

export type CardArt = 'framed' | 'ornament' | 'classic'

interface Props {
  faceUp: boolean
  /** Нужен, чтобы подобрать иллюстрацию; без него рисуется только символ. */
  cardId?: number
  sym: string
  title: string
  /** Мелкая подпись позиции в углу лицевой стороны. */
  label?: string
  /** Ранг карты (0…XXI у старших, A/2…10/P/N/Q/K у младших). */
  rank?: string
  reversed?: boolean
  art?: CardArt
  width?: number
  height?: number
  onClick?: () => void
  /** На мелких картах название не помещается — его прячут. */
  showTitle?: boolean
  /** Подпись для скринридера на закрытой карте; задаётся вызывающим экраном. */
  openLabel?: string
  style?: CSSProperties
}

/**
 * Карта из макета Card.dc.html: три стиля арта, рубашка с пульсирующим ромбом.
 * Переворот делает родитель (Home) — здесь только две стороны.
 */
export function TarotCard({
  faceUp,
  cardId,
  sym,
  title,
  label = '',
  rank = '',
  reversed = false,
  art = 'framed',
  width,
  height,
  onClick,
  showTitle = true,
  openLabel = 'Открыть карту',
  style,
}: Props) {
  const illustrated = cardId !== undefined && hasArt(cardId)

  const body = (
    <div
      className={`card${reversed && faceUp ? ' is-reversed' : ''}`}
      style={{ width: width ? `${width}px` : '100%', height: height ? `${height}px` : '100%', ...style }}
    >
      {faceUp ? (
        <div className="card__face">
          <div className={`card__art card__art--${art}${illustrated ? ' card__art--photo' : ''}`}>
            {illustrated ? (
              // Обёртка обрезает поля исходника; переворот вращает именно её,
              // иначе окно вырезки съехало бы относительно рисунка.
              <div className="card__photo">
                <img
                  src={artUrl(cardId!, (width ?? 0) > 0 && (width ?? 0) <= 70 ? 'sm' : 'lg')}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  draggable={false}
                  style={artImageStyle}
                />
              </div>
            ) : (
              <span className="card__sym">{sym}</span>
            )}
            {label && <span className="card__label">{label}</span>}
            {rank && <span className="card__rank">{rank}</span>}
          </div>
          {showTitle && <div className="card__title">{title}</div>}
        </div>
      ) : (
        <div className="card__back">
          <div className="card__back-inner">
            <div className="card__rune">
              <span>✦</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )

  if (!onClick) return body

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={faceUp ? title : openLabel}
      style={{ width: width ? `${width}px` : '100%', height: height ? `${height}px` : '100%', display: 'block' }}
    >
      {body}
    </button>
  )
}
